module.exports = __webpack_public_path__ + "static/media/referral.02c7f7b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/referral.svg
// module id = 1185
// module chunks = 0